export function LS_authUrlGet(): string {
    return localStorage.getItem('AUTH_URL')
}

export function LS_authUrlSet(authUrl: string) {
    localStorage.setItem('AUTH_URL', authUrl)
}

export function LS_authUrlRemove() {
    localStorage.removeItem('AUTH_URL')
}
